import { Injectable } from '@angular/core';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { UserSettingsService } from '@service/userSettings/user-settings.service';
import { CAPACITY_SEARCH_SETTINGS } from '@domain/constants/capacity-search-settings';
import { DefaultCapacitySearchSettings } from '@domain/interface/capacity-search-settings';

@Injectable({
	providedIn: 'root',
})
export class CapacitySearchSettingsService {
	constructor(
		private accountSettings: AccountSettingsService,
		private userSettings: UserSettingsService
	) {}

	getSettings(settingsFor: string): DefaultCapacitySearchSettings {
		if (settingsFor === CAPACITY_SEARCH_SETTINGS.settingType.userSetting) {
			return {
				searchableTrailerTypes: this.userSettings.SEARCHABLE_TRAILER_TYPES,
				defaultTrailerTypes: this.userSettings.DEFAULT_TRAILER_TYPES,
				pickupDateTypes: this.userSettings.PICKUP_DATE_TYPES,
				minimumTruckCount: this.userSettings.MINIMUM_TRUCK_COUNT,
				minimumFrequency: this.userSettings.MINIMUM_FREQUENCY,
				defaultPickupDateType: this.userSettings.DEFAULT_PICKUP_DATE_TYPE,
				defaultCapacitySearchTab: this.userSettings.DEFAULT_CAPACITY_SEARCH_TAB,
				searchTruckOriginDeadheadLimit: this.userSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT,
				searchTruckDestinationDeadheadLimit:
					this.userSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT,
				capacitySearchTabs: CAPACITY_SEARCH_SETTINGS.capacitySearchTabsListItems,
			};
		} else {
			return {
				searchableTrailerTypes: this.accountSettings.SEARCHABLE_TRAILER_TYPES,
				defaultTrailerTypes: this.accountSettings.DEFAULT_TRAILER_TYPES,
				pickupDateTypes: this.accountSettings.PICKUP_DATE_TYPES,
				minimumTruckCount: this.accountSettings.MINIMUM_TRUCK_COUNT,
				minimumFrequency: this.accountSettings.MINIMUM_FREQUENCY,
				defaultPickupDateType: this.accountSettings.DEFAULT_PICKUP_DATE_TYPE,
				defaultCapacitySearchTab: this.accountSettings.DEFAULT_CAPACITY_SEARCH_TAB,
				searchTruckOriginDeadheadLimit: this.accountSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT,
				searchTruckDestinationDeadheadLimit:
					this.accountSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT,
				capacitySearchTabs: CAPACITY_SEARCH_SETTINGS.capacitySearchTabsListItems,
			};
		}
	}
}
